import { PolymorphContent } from '../../directives/polymorph/types/content';

export type PrizmWidgetIcons = PolymorphContent<{ idx: number }>[] | PolymorphContent;
